import Vue from 'vue'
import VFC from 'vfc'
import VueFractionGrid from 'vue-fraction-grid/vue-fraction-grid'

import 'vfc/dist/vfc.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDoubleRight,
  faCaretSquareDown,
  faCaretSquareUp,
  faChevronDown,
  faCircle,
  faEnvelope,
  faGift,
  faGlassCheers,
  faImages,
  faMinus,
  faPlus,
  faRing,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import App from './views/App.vue'
import router from './router'

import assets from '@/assets'

library.add(
  faAngleDoubleRight,
  faCaretSquareDown,
  faCaretSquareUp,
  faCircle,
  faEnvelope,
  faImages,
  faMinus,
  faPlus,
  faUsers,
  faRing,
  faGlassCheers,
  faGift,
  faChevronDown,
)

Vue.prototype.$assets = assets

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(VFC)
Vue.use(VueFractionGrid, {
  container: '100%',
  approach: 'desktop-first',
  gutter: '1.5em',
  breakpoints: {
    compactInvite: '1024px',
    compact: '40em',
  },
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
